// @flow
import { titleToSlug } from '../../../services/titleToSlug'
import { numberToCurrency } from '../../../services/numberToCurrency'
import catalogMedia from './assets/catalog'

export default {
  productID: 'hardCoded.productID.complotGlass',
  title: 'hardCoded.title.complotGlass',
  slug: titleToSlug('hardCoded.title.complotGlass'),
  catalog: {
    title: 'hardCoded.catalog.title.complotGlass',
    catalogMedia,
    price: numberToCurrency('15'),
    color: '#8cced6'
  }
}
